

export enum MFConditionType {
    Equal                = 1,
    NotEqual             = 2,
    GreaterThan          = 3,
    LessThan             = 4,
    GreaterThanOrEqual   = 5,
    LessThanOrEqual      = 6,
    Contains             = 7,
}